(() => {
  const formatMoney = (value, currency) => new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency,
    maximumFractionDigits: 2
  }).format(Number.isFinite(value) ? value : 0);

  const initialize = (calculator) => {
    if (calculator.dataset.initialized === 'true') return;
    calculator.dataset.initialized = 'true';

    const orders = calculator.querySelector('[data-affiliate-orders]');
    const orderValue = calculator.querySelector('[data-affiliate-order-value]');
    const monthly = calculator.querySelector('[data-affiliate-monthly]');
    const yearly = calculator.querySelector('[data-affiliate-yearly]');
    const sales = calculator.querySelector('[data-affiliate-sales]');
    const rate = Number(calculator.dataset.rate) || 0;
    const currency = calculator.dataset.currency || 'EUR';

    const update = () => {
      const orderCount = Math.max(0, Number(orders.value) || 0);
      const averageValue = Math.max(0, Number(orderValue.value) || 0);
      const monthlySales = orderCount * averageValue;
      const monthlyCommission = monthlySales * rate;

      sales.textContent = formatMoney(monthlySales, currency);
      monthly.textContent = formatMoney(monthlyCommission, currency);
      yearly.textContent = formatMoney(monthlyCommission * 12, currency);
    };

    orders.addEventListener('input', update);
    orderValue.addEventListener('input', update);
    update();
  };

  const initializeAll = () => document.querySelectorAll('[data-affiliate-calculator]').forEach(initialize);
  document.addEventListener('DOMContentLoaded', initializeAll);
  document.addEventListener('shopify:section:load', initializeAll);
  initializeAll();
})();
